import React, { useState } from 'react';

export const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    institute: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleWhatsAppSubmit = (e) => {
    e.preventDefault();

    // NOTA: Para wa.me NO uses el "+", solo el código de país y el número.
    const myPhone = "+524291098621"; 

    // Formateamos el mensaje de forma más limpia
    const text = `*¡Hola! Me gustaría recibir información.*

👤 *Nombre:* ${formData.name}
📧 *Email:* ${formData.email}
🏫 *Instituto:* ${formData.institute}
📱 *Tel. contacto:* ${formData.phone}
💬 *Mensaje:* ${formData.message}`;

    // Usamos encodeURIComponent sobre el string completo para evitar errores de símbolos
    const whatsappUrl = `https://wa.me/${myPhone}?text=${encodeURIComponent(text)}`;

    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className='container py-5 d-flex align-items-center justify-content-center' style={{ minHeight: '80vh' }}>
      <div className='card border-0 shadow-lg overflow-hidden rounded-4 w-100' style={{ maxWidth: '950px' }}>
        <div className='row g-0'>
          
          <div className='col-lg-7 p-4 p-md-5 bg-white'>
            <h2 className='fw-bold mb-1 text-primary'>Escríbenos</h2>
            <p className='text-muted mb-4'>Completa los datos para generar tu mensaje.</p>
            
            <form className='row g-3' onSubmit={handleWhatsAppSubmit}>
              <div className='col-md-6'>
                <div className="form-floating">
                  <input type="text" className="form-control border-0 bg-light shadow-none" id="name" placeholder="Nombre" onChange={handleChange} required />
                  <label htmlFor="name" className='text-muted'>Tu nombre</label>
                </div>
              </div>
              
              <div className='col-md-6'>
                <div className="form-floating">
                  <input type="email" className="form-control border-0 bg-light shadow-none" id="email" placeholder="Email" onChange={handleChange} required />
                  <label htmlFor="email" className='text-muted'>Tu email</label>
                </div>
              </div>

              <div className='col-md-6'>
                <div className="form-floating">
                  <select className='form-select border-0 bg-light shadow-none' id="institute" onChange={handleChange} required>
                    <option value="">Selecciona Instituto</option>
                    <option value="San Pablo">ITSP - Teológico San Pablo</option>
                    <option value="Ministerial">IFM - Formación Ministerial</option>
                    <option value="Infantil">IPMI - Pastores Infantiles</option>
                    <option value="Música">IM - Música</option>
                  </select>
                  <label htmlFor="institute" className='text-muted'>Interés</label>
                </div>
              </div>

              <div className='col-md-6'>
                <div className="form-floating">
                  <input type="tel" className="form-control border-0 bg-light shadow-none" id="phone" placeholder="Teléfono" onChange={handleChange} required />
                  <label htmlFor="phone" className='text-muted'>Tu teléfono</label>
                </div>
              </div>

              <div className='col-12'>
                <div className="form-floating">
                  <textarea className="form-control border-0 bg-light shadow-none" id="message" style={{height: '120px'}} placeholder="Mensaje" onChange={handleChange} required></textarea>
                  <label htmlFor="message" className='text-muted'>¿En qué podemos ayudarte?</label>
                </div>
              </div>

              <div className='col-12 mt-4'>
                <button type='submit' className='btn-wsapp shadow-sm'>
                  <i className="bi bi-whatsapp me-2"></i>
                  Enviar Mensaje por WhatsApp
                </button>
              </div>
            </form>
          </div>

          <div className='col-lg-5 p-4 p-md-5 bg-primary text-white d-flex flex-column justify-content-center position-relative overflow-hidden'>
            {/* Adorno visual sutil */}
            <div className='position-absolute opacity-25' style={{ bottom: '-20px', right: '-20px' }}>
                <i className="bi bi-chat-dots-fill" style={{ fontSize: '10rem' }}></i>
            </div>

            <div className='position-relative' style={{ zIndex: 2 }}>
                <h4 className='fw-bold mb-4'>Atención Directa</h4>
                <p className='opacity-75 mb-4'>Al dar clic en el botón verde, se abrirá tu aplicación de WhatsApp con un mensaje pre-configurado con tus datos.</p>
                
                <hr className='opacity-25 mb-4'/>
                
                <div className='d-flex align-items-start mb-3'>
                  <i className="bi bi-geo-alt-fill me-3 mt-1"></i>
                  <div>
                    <span className='d-block fw-bold'>Sede</span>
                    <small className='opacity-75'>Irapuato, Gto.</small>
                  </div>
                </div>

                <div className='d-flex align-items-start mb-3'>
                  <i className="bi bi-clock-fill me-3 mt-1"></i>
                  <div>
                    <span className='d-block fw-bold'>Horario Sábado</span>
                    <small className='opacity-75'>7:00 AM - 3:00 PM</small>
                  </div>
                </div>
            </div>
          </div>

        </div>
      </div>

      <style>{`
        .btn-wsapp {
            background-color: #25d366;
            color: white;
            border: none;
            width: 100%;
            padding: 1rem;
            border-radius: 50px;
            font-weight: bold;
            font-size: 1.1rem;
            transition: all 0.3s ease;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .btn-wsapp:hover {
            background-color: #128c7e;
            transform: translateY(-2px);
            box-shadow: 0 5px 15px rgba(37, 211, 102, 0.4);
        }
        .form-control:focus, .form-select:focus {
            background-color: #f1f3f5 !important;
            border-left: 4px solid #0d6efd !important;
        }
        .ls-2 { letter-spacing: 2px; }
      `}</style>
    </div>
  );
};